// const carrousel = document.querySelector(".how-it-works-carousel");
// const cards = carrousel.querySelectorAll(".card");
// const arrows = carrousel.querySelectorAll(".arrows .arrow");
// const leftArrows = Array.from(arrows).filter((arrow, idx) => idx % 2 === 0);
// const rightArrows = Array.from(arrows).filter((arrow, idx) => idx % 2 === 1);

// All devices
// when clicking on an arrow from the arrows variable, it switches to the next/prior slide.
// If its a left arrow, then it's prior, if it's a right arrow then it's next
// One exception is when it's at the first slide, the prior arrow won't work, but at the last slide the next arrow will bring back to the first slide

// PC only
// Auto swipe to next card in carrousel, with a custom delay, when finished come back to the first card, following same logic as the buttons
// Hover on pc stops auto swipe
// Mousehover on card changes cursor to an arrow-cursor, if the cursor is on the right 50% of the card the arrow-cursor is turning right,
// Else the arrow-cursor turns left

// On Mobile | Tablet
// No autoswipe on mobile/tablet
// Swiping works on touch and works with the same logic as the buttons does

document.addEventListener("DOMContentLoaded", () => {
  const delay = 1500;
  // Define a function to initialize Swiper when it's available
  const initSwiper = () => {
    if (typeof Swiper !== "undefined") {
      new Swiper(".swiper-container", {
        // Set the slider direction to horizontal
        direction: "horizontal",
        // Enable continuous loop mode
        loop: false,
        // Show only one slide at a time
        slidesPerView: 1,
        // Set space (in px) between slides
        spaceBetween: 0,
        // Center the active slide
        centeredSlides: true,
        // Show grab cursor on hover for better UX
        grabCursor: true, // This enables cursor-grab and cursor-grabbing

        // Enable navigation using your custom button classes
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn",
        },

        // Enable autoplay with a 5s delay, and keep autoplay running after user interaction
        autoplay: {
          delay: delay,
          disableOnInteraction: true,
          pauseOnMouseEnter: true, // Pause autoplay when mouse is over the slider
        },

        // Responsive settings for screens >= 768px
        breakpoints: {
          768: {
            // Repeat autoplay settings for md+ screens
            autoplay: {
              delay: delay,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            },
          },
        },

        // Allow touch/swipe navigation (default in Swiper)
        touchRatio: 1, // Normal sensitivity (was 5, causing excessive swiping)
        touchAngle: 45, // Angle threshold for swipe detection
        shortSwipes: true, // Enable short swipes
        longSwipes: true, // Enable long swipes
        longSwipesRatio: 0.3, // Lower ratio for more controlled long swipes
        longSwipesMs: 200, // Shorter time for long swipes
        resistance: true, // Add resistance at edges
        resistanceRatio: 0.85, // Resistance strength

        // Improve responsive behavior and performance
        watchOverflow: true, // Disable Swiper if not enough slides
        watchSlidesProgress: true, // Track slide progress for effects
        watchSlidesVisibility: true, // Track which slides are visible

        // Additional touch controls for better swipe behavior
        threshold: 20, // Minimum distance for swipe to trigger (in px)
        touchStartPreventDefault: false, // Allow default touch behavior
        touchMoveStopPropagation: true, // Stop touch event propagation
        iOSEdgeSwipeDetection: true, // Better iOS swipe detection
        iOSEdgeSwipeThreshold: 20, // iOS edge swipe threshold

        // Force single slide movement only
        slidesPerGroup: 1, // Only move 1 slide at a time
        slidesPerView: 1,
        slidesPerGroupSkip: 0, // Don't skip any slides
        allowTouchMove: true, // Allow touch movement
        preventInteractionOnTransition: true, // Prevent interaction during transitions
      });
    } else {
      // If Swiper isn't loaded yet, retry after a short delay
      setTimeout(initSwiper, 100);
    }
  };

  // Start the Swiper initialization process
  initSwiper();

  // Debug: Check if buttons exist and add manual event listeners as backup
  setTimeout(() => {
    const nextBtns = document.querySelectorAll(".next-btn");
    const prevBtns = document.querySelectorAll(".prev-btn");

    // Add manual event listeners as backup
    nextBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const swiper = document.querySelector(".swiper-container").swiper;
        if (swiper) {
          console.log("Next button clicked, going to next slide");
          swiper.slideNext();
        }
      });
    });

    prevBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const swiper = document.querySelector(".swiper-container").swiper;
        if (swiper) {
          console.log("Prev button clicked, going to prev slide");
          swiper.slidePrev();
        }
      });
    });
  }, 500); // Wait for Swiper to initialize
});
